import { RootState } from '../reducers'

export const getIsLoadingProducts = (state: RootState) =>
  state.apiKey.isLoadingProducts
export const getProducts = (state: RootState) => state.apiKey.products
// `key` is `${servicePrincipalId}:${productId}` — see Store/ApiKey/slice.ts
export const getProductClaims = (key: string) => (state: RootState) =>
  state.apiKey.productClaims[key]
export const getProductClaimsMap = (state: RootState) =>
  state.apiKey.productClaims
export const getIsLoadingProductClaims = (key: string) => (state: RootState) =>
  state.apiKey.loadingProductClaims[key] || false
export const getIsCreatingApiKey = (state: RootState) => state.apiKey.isCreating
export const getCreatedApiKey = (state: RootState) => state.apiKey.createdApiKey
export const getApiKeys = (state: RootState) => state.apiKey.apiKeys
export const getIsLoadingApiKeys = (state: RootState) =>
  state.apiKey.isLoadingApiKeys
export const getIsRevokingApiKey = (state: RootState) => state.apiKey.isRevoking
export const getIsUpdatingApiKey = (state: RootState) => state.apiKey.isUpdating
export const getApiKeyUpdated = (state: RootState) => state.apiKey.apiKeyUpdated
export const getViewClaims = (state: RootState) => state.apiKey.viewClaims
export const getIsLoadingClaims = (state: RootState) => state.apiKey.isLoadingClaims
export const getListServicePrincipalId = (state: RootState) =>
  state.apiKey.listServicePrincipalId
export const getListStatusFilter = (state: RootState) =>
  state.apiKey.listStatusFilter
